import { useState } from 'react';
import { verifyAccountService } from '../services/accountVerification.service';
import { IdentifierType, VerifyAccountResponse } from '../_types/account.types';

interface UseAccountVerificationReturn {
  verifyAccount: (identifierType: IdentifierType, identifier: string) => Promise<VerifyAccountResponse | null>;
  loading: boolean;
  error: string | null;
  accountExists: boolean | null;
}

export const useAccountVerification = (): UseAccountVerificationReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [accountExists, setAccountExists] = useState<boolean | null>(null);
  
  const verifyAccount = async (
    identifierType: IdentifierType,
    identifier: string
  ): Promise<VerifyAccountResponse | null> => {
    if (loading) return null;
    
    try {
      setLoading(true);
      setError(null);
      
      const response = await verifyAccountService(identifierType, identifier);
      
      setAccountExists(response.exists);
      
      return response;
      
    } catch (err: any) {
      console.error('Erro na verificação da conta:', err);
      setError(err?.response?.data?.message || 'Erro ao verificar a conta');
      
      return null;
    } finally {
      setLoading(false);
    }
  };
  
  return {
    verifyAccount,
    loading,
    error,
    accountExists
  };
};
